import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'layout',
      component: () => import('@/components/layout'),
      children: [
        {
          path: '/',
          name: 'home',
          meta: {
            name: '首页',
            isMenu: true
          },
          component: () => import('@/views/home/home')
        },

        {
          path: '/product/5',
          name: 'product5',
          meta: {
            name: '光伏用电力监控',
            isMenu: true
          },
          component: () => import('@/views/product/index')
        },
        {
          path: '/product/1',
          name: 'precisionEngineering',
          meta: {
            name: '钣金加工',
            isMenu: true
          },
          component: () => import('@/views/product/index')
        },
        {
          path: '/product/2',
          name: 'precisionMachining',
          meta: {
            name: '精密加工',
            isMenu: true
          },
          component: () => import('@/views/product/precisionMachining.vue')
        },
        {
          path: '/product/3',
          name: 'oem',
          meta: {
            name: 'OEM模组',
            isMenu: true
          },
          component: () => import('@/views/product/oem.vue')
        },
        {
          path: '/product/4',
          name: '注塑加工',
          meta: {
            name: '注塑加工',
            isMenu: true
          },
          component: () => import('@/views/product/molding.vue')
        },
        // {
        //   path: '/product/3',
        //   name: 'product3',
        //   meta: {
        //     name: '成套设备',
        //     isMenu: true
        //   },
        //   component: () => import('@/views/product/index')
        // },

        {
          path: '/news',
          name: 'news',
          meta: {
            name: '新闻资讯',
            isMenu: true
          },
          component: () => import('@/views/news/news')
        },
        {
          path: '/newsDetails',
          name: 'newsDetails',
          meta: {
            name: '新闻详情',
            isMenu: true
          },
          component: () => import('../views/news/newsDetails')
        },
        // {
        //   path: '/solution',
        //   name: 'solution',
        //   meta: {
        //     name: '业务领域',
        //     isMenu: true
        //   },
        //   component: () => import('@/views/solution/index')
        // },
        // {
        //   path: '/solution/one',
        //   name: 'solutionone',
        //   meta: {
        //     name: '智能输配电',
        //     isMenu: true
        //   },
        //   component: () => import('@/views/solution/one')
        // },
        // {
        //   path: '/solution/two',
        //   name: 'solutiontwo',
        //   meta: {
        //     name: '施工与运维',
        //     isMenu: true
        //   },
        //   component: () => import('@/views/solution/two')
        // },
        // {
        //   path: '/solution/three',
        //   name: 'solutionthree',
        //   meta: {
        //     name: '动环监测',
        //     isMenu: true
        //   },
        //   component: () => import('@/views/solution/three')
        // },
        {
          path: '/introduce',
          name: 'introduce',
          meta: {
            name: '公司简介',
            isMenu: true
          },
          component: () => import('@/views/about/introduce')
        },
         {
          path: '/qualifications',
          name: 'qualifications',
          meta: {
            name: '资质荣誉',
            isMenu: true
          },
          component: () => import('@/views/about/qualification.vue')
        },
        {
          path: '/recruit',
          name: 'recruit',
          meta: {
            name: '加入我们',
            isMenu: true
          },
          component: () => import('@/views/about/recruit')
        },
        {
          path: '/contact',
          name: 'contact',
          meta: {
            name: '联系我们',
            isMenu: true
          },
          component: () => import('@/views/about/contact')
        },
        {
          path: '/recruitDetails',
          name: 'recruitDetails',
          meta: {
            name: '招聘详情',
            isMenu: true
          },
          component: () => import('@/views/about/recruitDetails')
        },
        {
          path: '/demeanor',
          name: 'demeanor',
          meta: {
            name: '企业风采',
            isMenu: true
          },
          component: () => import('@/views/about/demeanor')
        },
        {
          path: '/demeanorDetails',
          name: 'demeanorDetails',
          meta: {
            name: '企业风采',
            isMenu: true
          },
          component: () => import('../views/about/demeanorDetails')
        },
        {
          path: '/qualification',
          name: 'qualification',
          meta: {
            name: '企业资质',
            isMenu: true
          },
          component: () => import('../views/about/qualification')
        }
      ]
    }
  ]
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js